import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';

import DialogShell from '@/components/DialogShell';
import { useUIStore } from '@/stores/useUIStore';

const SyneraInfoDialog: React.FC = () => {
  const open = useUIStore((s) => s.syneraInfoDialogOpen);
  const closeDialog = useUIStore((s) => s.closeDialog);

  const handleClose = () => closeDialog('syneraInfoDialog');

  return (
    <DialogShell
      open={open}
      onClose={handleClose}
      title="Synera Export"
      titleColor="info.main"
      icon={<InfoIcon color="info" sx={{ fontSize: 28 }} />}
      maxWidth={480}
      actions={
        <Button variant="contained" color="info" onClick={handleClose}>
          OK
        </Button>
      }
    >
      <Typography variant="body2">
        Please replace your username in the Synera input sheet to receive Synera status emails.
      </Typography>
    </DialogShell>
  );
};

export default SyneraInfoDialog;
